import React, { Component } from "react";
import PropTypes from "prop-types";
import TextField from "../TextField";
import NumberField from "../NumberField";
import ToggleButton from "../ToggleButton";
import DateField from "../DateField";
import Dropdown from "../Dropdown";
import EmailField from "../EmailField";
import TextAreaField from "../TextAreaField";
import PhotoControl from "../PhotoControl";
import CheckboxField from "../CheckboxField";
import Signature from "../Signature";
import LabelArea from "../LabelArea";
import { Form } from "semantic-ui-react";
import AddressSearch from "../AddressSearch";
import CalculateField from "../CalculateField";
import TotalField from "../TotalField";
import StaticImageField from "../StaticImageField";
import LookupField from "../LookupField";
import LookupText from "../LookupText";
import RepeatingForm from "../RepeatingForm";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AppActions from "../../actions";
import _ from "lodash";

class FormControl extends Component {
  renderLabel() {
    const { element_parent, element_prompt } = this.props;
    if (element_parent === 0)
      return (
        <div className="formControlItem">
          <Form.Field>
            <span className="formSectionTitle">{element_prompt}</span>
          </Form.Field>
        </div>
      );

    return (
      <Form.Field>
        <label>{element_prompt}</label>
      </Form.Field>
    );
  }

  renderPage() {
    const { element_prompt } = this.props;
    return null;
  }

  renderControl() {
    const {
      element_type,
      element_value,
      repeatingFormUUID,
      element_visible,
      section,
      error,
      isLoading,
      repeatingForm,
      validate,
      ...formControl
    } = this.props;

    if (element_visible == "0") {
      return <div></div>;
    }

    let implemented = [
      "1",
      "2",
      "3",
      "5",
      "6",
      "7",
      "8",
      "10",
      "11",
      "12",
      "14",
      "15",
      "16",
      "17",
      "22",
      "31",
      "24",
      "25"
    ];

    if (implemented.indexOf(element_type) !== -1) {
      if (element_type === "22") {
        var repeatingFormItemsX = _.filter(this.props.formControls, function(
          control
        ) {
          return (
            Number(control.element_parent) === Number(formControl.element_id)
          );
        });

        let mandatory = false;
        let repeatingFormItemsXi = [];
        repeatingFormItemsX.forEach(element => {
          if (element.element_type === "24") {
            repeatingFormItemsXi = _.filter(this.props.formControls, function(
              control
            ) {
              return (
                Number(control.element_parent) === Number(element.element_id)
              );
            });
            repeatingFormItemsXi.forEach(element => {
              if (element.element_optional === "0") {
                mandatory = true;
              }
            });
          } else {
            if (element.element_optional === "0") {
              mandatory = true;
            }
          }
        });
        if (mandatory) {
          formControl.element_optional = "0";
          this.props.setMandatory(this.props.section, this.props.element_id);
        }
      } else {
        if (this.props.element_optional === "0") {
          this.props.setMandatory(this.props.section, this.props.element_id);
        }
      }
    }

    switch (element_type.toString()) {
      case "1":
        return (
          <TextField
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></TextField>
        );
      case "2":
        return (
          <TextAreaField
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></TextAreaField>
        );
      case "3":
        return (
          <NumberField
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></NumberField>
        );
      case "5":
        return (
          <CheckboxField
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></CheckboxField>
        );
      case "6":
        return (
          <DateField
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></DateField>
        );
      case "7":
        return (
          <Signature
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></Signature>
        );
      case "8":
        return (
          <PhotoControl
            repeatingForm={repeatingForm}
            validate={validate}
            isLoading={isLoading}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></PhotoControl>
        );
      case "10":
        return (
          <LabelArea
            repeatingForm={repeatingForm}
            {...formControl}
            element_value={element_value}
          ></LabelArea>
        );
      case "11":
        return (
          <Dropdown
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></Dropdown>
        );
      case "12":
        return (
          <ToggleButton
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></ToggleButton>
        );
      case "14":
        return (
          <AddressSearch
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></AddressSearch>
        );
      case "15":
        return (
          <EmailField
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></EmailField>
        );
      case "16":
        return (
          <LookupField
            repeatingFormUUID={repeatingFormUUID}
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></LookupField>
        );
      case "17":
        return (
          <LookupText
            repeatingFormUUID={repeatingFormUUID}
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></LookupText>
        );
      case "18":
        return (
          <CalculateField
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></CalculateField>
        );
      case "19":
        return (
          <TotalField
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></TotalField>
        );
      case "22":
        return (
          <RepeatingForm
            repeatingForm={repeatingForm}
            validate={validate}
            error={error}
            {...formControl}
            element_id={Number(formControl.element_id)}
            element_value={element_value}
            onChange={this.props.onChange}
          ></RepeatingForm>
        );
      case "31":
        return (
          <StaticImageField
            repeatingForm={repeatingForm}
            {...formControl}
            element_value={element_value}
          ></StaticImageField>
        );
      case "24":
        return this.renderLabel();
      case "25":
        return this.renderPage();
      default:
        return <div></div>;
    }
  }

  render() {
    return <div id={"page" + this.props.page}>{this.renderControl()}</div>;
  }
}

FormControl.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_parent: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  repeatingForm: PropTypes.bool,
  page: PropTypes.number,
  element_type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  section: PropTypes.number
};

const mapStateToProps = state => ({
  formControls: state.form.data
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormControl);



// WEBPACK FOOTER //
// ./src/components/FormControl/index.js